import Remove from './remove';

export default Remove;